import React from "react";
import ReferenceItem from "./ReferenceItem";

function ReferenceList({references, onEdit, onDelete}) {
    return (
        <div>
            {references.length > 0 ? (
                references.map((reference) => (
                    <ReferenceItem
                        key={reference.id}
                        reference={reference}
                        onEdit={() => onEdit(reference)}
                        onDelete={() => onDelete(reference.id)}
                    />
                ))
            ) : (
                <div className="text-center">
                    <h4>No references</h4>
                    <p className="text-muted small">No references added yet. Add your reference to build your CV.</p>
                </div>
            )}
        </div>
    );
}

export default ReferenceList;
